import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { filterProductOptionsByMarket } from '@/common/functions/filterProductOptionsByMarket';
import { formatToDateTamplate } from '@/common/functions/dateFormater';
import { SERP_MONITORING_SELECT_MARKET_AND_PRODUCT } from '@/common/constants/serpMonitoring';
import moment from 'moment';
import { useRef, useState } from 'react';

const getLastMonday = () => formatToDateTamplate(moment().isoWeekday(1));

const SerpMonitoringReportSearchBox = ({
	onSearch,
	onBuildXlsx,
	isLoading,
}) => {
	const {
		options: { marketsOptions, productsOptions },
		commonData: { queues },
	} = useCommonDataContext();
	const { addMessage } = useMessageQueueContext();
	const [market, setMarket] = useState();
	const [product, setProduct] = useState();
	const dateFromRef = useRef();
	const dateToRef = useRef();

	const lastMonday = getLastMonday();

	const productOptions = filterProductOptionsByMarket(
		queues,
		productsOptions,
		market?.value,
	);

	const handleMarketChange = (nextMarket) => {
		setMarket(nextMarket);
		setProduct(null);
	};

	const handleSearch = (event) => {
		event.preventDefault();
		const hasMarketAndProduct = market?.value && product?.value;

		if (!hasMarketAndProduct) {
			addMessage(SERP_MONITORING_SELECT_MARKET_AND_PRODUCT, 'error');
			return;
		}

		const dateFrom = new Date(dateFromRef.current.value).toISOString();
		const dateTo = new Date(dateToRef.current.value).toISOString();

		onSearch({
			market: market.value,
			product: product.value,
			dateFrom,
			dateTo,
		});
	};

	return (
		<form onSubmit={handleSearch}>
			<SearchBarCenter>
				<SelectInput
					name='Market'
					color={Colors.darkBlue}
					width={140}
					selectWidth={220}
					required
					options={marketsOptions}
					selected={market}
					setSelected={handleMarketChange}
				/>
				<SelectInput
					name='Product'
					color={Colors.darkBlue}
					width={140}
					selectWidth={220}
					required
					options={productOptions}
					selected={product}
					setSelected={setProduct}
					disabled={!market}
				/>
				<Input
					name='From date'
					width={140}
					color={Colors.darkBlue}
					inputRef={dateFromRef}
					type='date'
					value={lastMonday}
					inputWidth={140}
				/>
				<Input
					name='To date'
					width={140}
					color={Colors.darkBlue}
					inputRef={dateToRef}
					type='date'
					value={lastMonday}
					inputWidth={140}
				/>
				<ActionButton type='submit' text='Search' disabled={isLoading} />
				<ActionButton
					type='button'
					text='Generate XLSX report'
					disabled={isLoading}
					onClick={onBuildXlsx}
				/>
			</SearchBarCenter>
		</form>
	);
};

export default SerpMonitoringReportSearchBox;
